import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';

interface LazyImageProps {
    src: string;
    alt?: string;
    className?: string;
}

const LazyImage: React.FC<LazyImageProps> = ({ src, alt = '', className = '' }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <div className="relative w-full">
                {/* 加载占位符 */}
                {isLoading && (
                    <div className="w-full bg-gray-200 animate-pulse rounded-lg overflow-hidden" 
                        style={{ 
                            minHeight: '12rem',
                            paddingBottom: '56.25%'
                        }}
                    >
                        <div className="absolute inset-0 overflow-hidden">
                            <div 
                                className="absolute inset-0 bg-gradient-to-r from-transparent via-gray-300/60 to-transparent skeleton-loading"
                                style={{
                                    width: '200%',
                                    left: '-50%'
                                }}
                            />
                        </div>
                    </div>
                )}
                
                {/* 实际图片 */}
                <img
                    src={src}
                    alt={alt}
                    className={`${className} ${isLoading ? 'hidden' : 'block'} w-full h-auto rounded-lg transition-opacity duration-300 cursor-zoom-in`}
                    onLoad={() => setIsLoading(false)}
                    onError={() => {
                        setIsLoading(false);
                        setError(true);
                    }}
                    onClick={() => !error && setIsOpen(true)}
                />

                {/* 加载错误显示 */}
                {error && (
                    <div className="w-full bg-gray-100 rounded-lg flex items-center justify-center" 
                        style={{ 
                            minHeight: '12rem',
                            paddingBottom: '56.25%'
                        }}
                    >
                        <div className="absolute inset-0 flex items-center justify-center">
                            <span className="text-gray-400">图片加载失败</span>
                        </div>
                    </div>
                )}
            </div>

            {/* 图片预览 */}
            <Lightbox
                open={isOpen}
                close={() => setIsOpen(false)}
                slides={[{ src, alt }]}
                plugins={[Zoom]}
                zoom={{
                    maxZoomPixelRatio: 5, // 最大缩放比例
                    scrollToZoom: true,   // 允许滚轮缩放
                    wheelZoomDistanceFactor: 100,  // 滚轮缩放速度
                    doubleClickMaxStops: 2,  // 双击缩放级别
                    doubleClickDelay: 300,   // 双击延迟
                }}
                render={{
                    buttonPrev: () => null,
                    buttonNext: () => null,
                    iconZoomIn: () => null,  // 隐藏默认的缩放图标
                    iconZoomOut: () => null,  // 隐藏默认的缩放图标
                }}
            />
        </>
    );
};

export default LazyImage; 